import request from "../request"
/**
 * 天地图秘钥
 */
// const TDU_KEY = "067a47f8f1b59ae00fc99751bef413bc"

// export function searchMap(keyWord) {
// 	let postStr = {
// 		keyWord,
// 		queryType: 1,
// 		mapBound: "60,0,140,20",
// 		// specify:156000000,
// 		start: 0,
// 		count: 10,
// 		level: 13
// 	}
// 	return request.get(
// 		{
// 			url:"/tianditu-proxy/v2/search",
// 			showLoading:false,
// 			params: {
// 				postStr: JSON.stringify(postStr),
// 				type: 'query',
// 				tk: TDU_KEY
// 			}
// 		}
// 	)
	
	
// }

export function searchMap(keywords) {
	
	return request.get(
		{
			url:"/gdMap/v5/place/text",
			showLoading:false,
			params: {
				keywords,
				key:'25a9d8ba998706019c29ce6794c8c021'
			}
		}
	)
	
	
}

export function searchFlightLine(params) {
	
	return request.get(
		{
			url:"/route-information/list",
			params
		}
	)
	
	
}

export function searchFlightLineDetail(params) {
	
	return request.get(
		{
			url:"/route-information/orderId",
			params
		}
	)
	
	
}